function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { GroupScreen } from '@leverege/molten/screens';
import OpenApiGroupDelegate from "../../delegates/openApi/OpenApiGroupDelegate.js";
export default ({
  id,
  relationship,
  isRoot
}) => ({
  id,
  exact: true,
  path: `/${relationship.urlPath}`,
  default: relationship.hasTag('is:preferredView'),
  matches: isRoot ? {
    client: 'Main'
  } : {
    client: 'ItemScreen',
    path: relationship.parentRelationship.path
  },
  render: props => {
    const rel = relationship.createResolved(props.match);
    return /*#__PURE__*/React.createElement(GroupScreen, _extends({}, props, {
      relationship: rel,
      icon: relationship.getIcon('groupScreenIcon'),
      objectType: rel.objectType,
      delegate: new OpenApiGroupDelegate({
        relationship: rel,
        match: props?.match
      })
    }));
  }
});